import {authHeader, isTokenExpired} from '../helpers';

export const adminDmaPageService = {
  fetchAdminDmaPage,
  updateAdminDmaPage
};

function fetchAdminDmaPage(isUser = false) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const url = isUser ? `${process.env.REACT_APP_GATEWAY_URL}/page` : `${process.env.REACT_APP_GATEWAY_URL}/admin/page`;
  return fetch(url, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }
      // 204 for no home page == empty response
      else if (res.status === 204) {
        return {};
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateAdminDmaPage(dmaPage, headers) {
  const formData = new FormData()
  formData.append('page', JSON.stringify(dmaPage))
  for (const header of headers) {
    formData.append('headers', header.file, header.name)
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(true),
    body: formData,
  }
  const url = process.env.REACT_APP_GATEWAY_URL + '/admin/page/';

  return fetch(url, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
